import VendorInvoicePage from "./VendorInvoicePage";
import { invoicePermissionProfile } from "components/Authorize/permissionProfiles/invoicePermissionProfile";
import { TabsWrapper } from "components/TabsWrapper/TabsWrapper";
import VendorInvoiceFilesPage from "../vendorInvoiceFile/VendorInvoiceFilesPage";

const VendorInvoicesTabsPage = () => {
    const tabs = [
        {
            key: "invoices",
            label: "Vendor Invoices",
            component: <VendorInvoicePage />,
            permission: invoicePermissionProfile.VIEW_VENDOR_INVOICE
        },
        {
            key: "files",
            label: "File List",
            component: <VendorInvoiceFilesPage />,
            permission: invoicePermissionProfile.VIEW_VENDOR_INVOICE_FILE
        }
    ];

    return (
        <TabsWrapper tabs={tabs} selectedTab={0} />
    );
};

export default VendorInvoicesTabsPage;
